import React, {useEffect} from 'react';
import styled from 'styled-components';

import {ChromePicker} from 'react-color';

interface Props {
    showColorPicker: boolean;
    onChange: ChromePicker['props']['onChange'];
    color: string;
    toggleColorPicker: () => void;
    style?: React.CSSProperties;
    pickerRight?: string;
}

const ColorPickerToggleButton = styled.button`
    border-width: 1px;
    border-radius: 4px;
    border-style: solid;
    border-color: #383b43;
    width: 38px;
    height: 38px;
`;

export const StyledPicker = styled(ChromePicker)<Pick<Props, 'pickerRight'>>`
    position: absolute;
    right: ${(props) => props.pickerRight || '13px'};
    z-index: 10000;
`;

export const ColorPicker: React.FC<React.PropsWithChildren<Props>> = ({
    showColorPicker,
    onChange,
    color,
    toggleColorPicker,
    pickerRight,
    style,
}) => {
    useEffect(() => {
        const onClickOutside = (e: MouseEvent) => {
            if (showColorPicker) {
                toggleColorPicker();
            }
        };
        if (showColorPicker) {
            window.addEventListener('click', onClickOutside);
        }

        return () => {
            window.removeEventListener('click', onClickOutside);
        };
    }, [toggleColorPicker, showColorPicker]);

    return (
        <div
            style={style}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <ColorPickerToggleButton
                style={{backgroundColor: color}}
                onClick={toggleColorPicker}
            ></ColorPickerToggleButton>
            {showColorPicker && <StyledPicker color={color} onChange={onChange} pickerRight={pickerRight} />}
        </div>
    );
};
